<template>
  <div
    :class="cssClasses">
    <span class="day-number">
      {{ dayNumber }}
    </span>
    <br>
    <d-badge
      v-if="itemData"
      tag="div"
      pill
      class="day-info"
      theme="primary">
      {{ itemData.length }}

      <span
        v-if="itemData"
        class="for-desktop">
        {{ dayInfoFormatted }}
      </span>
    </d-badge>
  </div>
</template>
<script>

export default {
  name: 'calendar-day',
  props: [
    'itemData',
    'dayData',
    'isCurrentDay'
  ],
  computed: {
    dayInfoFormatted () {
      if (this.itemData.length === 1) {
        return 'spotkanie';
      }
      if (this.itemData.length > 1 && this.itemData.length < 5) {
        return 'spotkania';
      }
      return 'spotkań';
    },
    isPastDay () {
      if (this.dayData.isToday) {
        return false;
      }

      let dateParts = this.dayData.date.split('-').map(n => parseInt(n, 10));
      let dateObject = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      let today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setMilliseconds(0);

      if (dateObject < today) {
        return true;
      }

      return false;
    },
    cssClasses () {
      if (this.dayData) {
        return {
          'day': true,
          'is-today': this.dayData.isToday,
          'is-different-month': !this.dayData.isCurrentMonth,
          'is-past': this.isPastDay
        };
      }

      return {
        'day': true,
        'is-current': this.isCurrentDay
      };
    },
    dayNumber () {
      if (this.dayData) {
        return this.dayData.number;
      }

      if (!this.itemData) {
        return '-';
      }

      return parseInt(this.itemData.date.split('-')[2], 10);
    }
  }
}
</script>

<style lang="scss" scoped>
.day {
  border-right: 1px solid #e1e5eb;
  border-bottom: 1px solid #e1e5eb;
  cursor: pointer;
  height: 110px;
  padding: 1rem;
  position: relative;
  width: calc(100% / 7);

  &:nth-child(7n - 1) {
    background: repeating-linear-gradient(45deg, rgba(0, 0, 0, .06), rgba(0, 0, 0, .06) 20px, #fff 0, #fff 40px);
  }

  &:nth-child(7n) {
    background: repeating-linear-gradient(45deg, rgba(0, 0, 0, .06), rgba(0, 0, 0, .06) 20px, #fff 0, #fff 40px);
    border-right: none;
  }

  &:hover {
    background: lighten(#007bff, 42.5%);

    &:before {
      border: 3px solid #007bff;
      border-radius: 5px;
      content: "";
      height: calc(100% + 6px);
      position: absolute;
      pointer-events: none;
      right: -3px;
      top: -3px;
      width: calc(100% + 6px);
      z-index: 1;
    }
  }

  .day-info {
    font-size: .75rem;
    margin: 10px auto 5px auto;
    min-width: 24px;
  }
  &.is-today {
    background: #ffb4001c;
  }

  &.is-current {
    background: #00b8d8;
    border-color: #00b8d8;
    color: #CACEDB;

    &:after {
      border: 10px solid #00b8d8;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      content: "";
      left: calc(50% - 10px);
      position: absolute;
      top: -20px;
    }
  }

  &.is-different-month {
    background: #e9ecef;
    opacity: .33;
  }

  &.is-past {
    & > * {
      opacity: .35;
    }
  }

  &-number {
    font-size: 1.5rem;
  }

  &-closed {
    bottom: 1.8rem;
    color: #c4183c;
    font-size: 1.3rem;
    font-weight: bold;
    opacity: .75;
    position: absolute;
    right: 1rem;
  }
}

@media (max-width: 1240px) {
  .day {
    padding: 0.9rem;
  }
}

@media (max-width: 960px) {
  .day {
    height: 90px;
    padding: .5rem 1rem;
  }

  .for-desktop {
    display: none!important;
  }
}

@media screen and (max-width: 768px) {
  .day-number {
    font-size: 1.4rem;
  }
}

@media (max-width: 640px) {
  .day {
    height: 64px;
    padding: .25rem .5rem;

    &-number {
      font-size: 1.2rem;
    }

    .day-info {
      margin-top: 0px;
    }
  }
}
</style>
